"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactRole = void 0;
var ContactRole;
(function (ContactRole) {
    ContactRole["PRIMARY"] = "primary";
    ContactRole["SECONDARY"] = "secondary";
})(ContactRole || (exports.ContactRole = ContactRole = {}));
